import { Button, Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import FilterLineBeginning from './components/FilterLineBeginning';
import FilterLineEnd from './components/FilterLineEnd';
import FilterMenu from './components/FilterMenu';
import FilterPopupMenu from './components/FilterPopupMenu';

const FilterLine = ({ possibleFilters, filters, setFilters, resetFilters, defaultValues = [] }) => {
    const [open, setOpen] = React.useState(false);
    const [items, setItems] = useState([
        ...defaultValues,
        ...possibleFilters
            .filter(
                p =>
                    Object.keys(filters).includes(p.key) &&
                    filters[p.key] !== '' &&
                    filters[p.key] !== null
            )
            .map(e => {
                if (e.type === 'daterange') {
                    return {
                        label: e.label,
                        key: e.key,
                        type: e.type,
                        rangeKeys: e.rangeKeys,
                        value: [filters[e.rangeKeys[0]], filters[e.rangeKeys[1]]]
                    };
                }
                if (e.type === 'date' || e.type === 'datetime') {
                    return {
                        label: e.label,
                        key: e.key,
                        type: e.type,
                        value: filters[e.key]
                    };
                }
                return {
                    label: e.label,
                    key: e.key,
                    type: e.type,
                    value: filters[e.key]
                };
            })
    ]);

    const anchorRef = React.useRef(null);

    const handleFilterChange = useCallback(
        (item, value) => {
            if (item.type === 'daterange') {
                setFilters({
                    ...filters,
                    [item.rangeKeys[0]]: value?.[0],
                    [item.rangeKeys[1]]: value?.[1]
                });
                return;
            }
            if (item.type === 'date' || item.type === 'datetime') {
                setFilters({
                    ...filters,
                    [item.key]: value
                });
                return;
            }

            setFilters({
                ...filters,
                [item.key]: value
            });
        },
        [filters, setFilters]
    );

    // list of the currently unused filters
    const unusedFilters = possibleFilters.filter(e => !items.map(k => k.key).includes(e.key));

    useEffect(() => {
        if (open === true) {
            return;
        }

        anchorRef.current.focus();
    }, [open]);

    const handleItemChange = (newItem, idx) => {
        handleFilterChange(newItem, newItem.value);
        setItems(items.map((e, i) => (idx === i ? newItem : e)));
    };

    const handleToggle = useCallback(() => {
        setOpen(o => !o);
    }, [setOpen]);
    /**
     * IMPORTANT: currently we only allow one filter option per type, so we keep the key as the type
     * If that one changes in the future, try to figure out a better method to prevent rerendering
     */
    return (
        <Grid container item className="searchfilter-wrapper">
            <Grid item>
                <FilterLineBeginning />
                {items.map((item, idx) => (
                    <FilterMenu
                        key={item.key}
                        item={items[idx]}
                        setItem={newItem => handleItemChange(newItem, idx)}
                        clearItem={val => {
                            handleFilterChange(items[idx], val.value);
                            setItems(items.filter(e => e.key !== val.key && e !== ''));
                        }}
                        options={unusedFilters}
                        handleOptionClick={option => {
                            handleFilterChange(items[idx], option.value);
                            setItems(
                                items.map((prevItem, i) =>
                                    i === idx
                                        ? {
                                              label: option.label,
                                              key: option.key,
                                              rangeKeys:
                                                  option.type === 'daterange'
                                                      ? option.rangeKeys
                                                      : '',
                                              value:
                                                  option.type === 'daterange'
                                                      ? [null, null]
                                                      : option.type === 'date' ||
                                                        option.type === 'datetime'
                                                      ? null
                                                      : '',
                                              type: option.type
                                          }
                                        : prevItem
                                )
                            );
                        }}
                    />
                ))}
                {open && (
                    <FilterPopupMenu
                        open
                        anchorRef={anchorRef}
                        setOpen={setOpen}
                        options={unusedFilters}
                        handleOptionClick={option => {
                            setItems([
                                ...items,
                                {
                                    label: option.label,
                                    key: option.key,
                                    rangeKeys: option.type === 'daterange' ? option.rangeKeys : '',
                                    value:
                                        option.type === 'daterange'
                                            ? [null, null]
                                            : option.type === 'date' || option.type === 'datetime'
                                            ? null
                                            : '',
                                    type: option.type
                                }
                            ]);
                            setOpen(false);
                        }}
                    />
                )}
                <FilterLineEnd
                    disabled={items.length === possibleFilters.length}
                    open={open}
                    onClick={handleToggle}
                    anchorRef={anchorRef}
                />
            </Grid>
            <Grid item>
                <Button
                    disabled={items.length === 0}
                    size="small"
                    type="text"
                    onClick={() => {
                        setItems([]);
                        resetFilters();
                    }}
                >
                    Clear
                </Button>
            </Grid>
        </Grid>
    );
};

export default FilterLine;
